// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__0vG1A"};